import { GlobalsHeaderNav } from '@/tina/__generated__/types';
import * as stylex from '@stylexjs/stylex';
import { tinaField } from 'tinacms/dist/react';
import '../../styles/tokens.stylex';
import { borderRadius, fontSizes, layoutTokens, spacing } from '../../styles/tokens.stylex';
import { typography } from '../../styles/typography';
import { CloseMenuButton, DynamicHeaderLayout, MenuLink } from './ClientComponents';
import { NextLinkWithEventPayload } from '../NextLinkWithEventPayload';
interface NavigationProps {
  data?: GlobalsHeaderNav[];
}
export function HeaderNav({
  data
}: NavigationProps) {
  return data ? <DynamicHeaderLayout wrapperStyles={sx.wrapper} navStyles={sx.nav} menuButtonStyles={sx.navButton} actionButtonStyles={sx.actionButtonStyles} desktopNavWrapperStyles={sx.desktopNavWrapper} desktopNav={<ul className="x78zum5 xe8uvvx x1717udv x1ghz6dp x1mhrlx8">
          {data.map((item, i) => {
      const key = `${i}_${item?.label.toLowerCase().split(/ /g).join('-')}`;
      const pageUrl = `/${item.link._sys.breadcrumbs.join('/')}`;
      return <li key={key}>
                <NextLinkWithEventPayload href={pageUrl} {...stylex.props(typography.body, sx.navLink)} data-tina-field={tinaField(item, 'label')} clickEventPayload={{
          event: 'navigation_link_click',
          location: 'header',
          href: item?.link._sys.breadcrumbs.join('/')
        }}>
                  {item?.label}
                </NextLinkWithEventPayload>
              </li>;
    })}
        </ul>} mobileNav={<>
          <div className="x78zum5 x13a6bvl xmqgjvl xs2893t xlqtsic">
            <CloseMenuButton styles={sx.navButton}>
              Close Navigation Menu
            </CloseMenuButton>
          </div>
          <ul className="xe8uvvx x1ghz6dp x1717udv xrvj5dj x1mhrlx8 xox9ipt x1y8v6su">
            {data.map((item, i) => {
        const key = `${i}_${item?.label.toLowerCase().split(/ /g).join('-')}`;
        const pageUrl = `/${item.link._sys.breadcrumbs.join('/')}`;
        return <li key={key}>
                  <MenuLink href={pageUrl} {...stylex.props(typography.display2, sx.navLink, sx.mobileLink)} data-tina-field={tinaField(item, 'label')} clickEventPayload={{
            event: 'navigation_link_click',
            location: 'mobile_menu',
            href: item?.link._sys.breadcrumbs.join('/')
          }}>
                    {item?.label}
                  </MenuLink>
                </li>;
      })}
          </ul>
        </>} /> : null;
}
const LARGE_VIEWPORTS = '@container (min-width: 900px)' as const;
const sx = {
  wrapper: {
    k1xSpc: "x78zum5",
    kGNEyG: "x6s0dn4",
    kSGwAc: "xamitd3",
    $$css: true
  },
  nav: {
    kzqmXN: "xeq5yr9",
    $$css: true
  },
  navButton: {
    kAzted: "x1t4djm1",
    kZKoxP: "x1vqgdyp",
    kaIpWk: "xakuvmb",
    k1xSpc: "x78zum5 x8ukn6a",
    $$css: true
  },
  desktopNavWrapper: {
    k1xSpc: "x1s85apg x17xt3wk",
    kGNEyG: "x6s0dn4",
    k1C7PZ: "xoj165o",
    khm7nJ: "x1x2dswl",
    kwnvtZ: "x8hhl5t",
    kjj79g: "x13a6bvl",
    $$css: true
  },
  navLink: {
    kybGjl: "x1hl2dhg",
    $$css: true
  },
  mobileLink: {
    kGuDYH: "xxo84ja",
    $$css: true
  },
  actionButtonStyles: {
    kGuDYH: "x1tnq2d2",
    $$css: true
  }
};